import axios from 'axios';
import store from 'redux/store';
import { showLoginModal } from 'redux/ui/uiSlice';

const createCanguardNotificationsApiInstance = () => {
  const baseURL =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
      ? 'http://localhost:10000/api3.2/canguard/notifications'
      : '/api3.2/canguard/notifications';

  const instance = axios.create({ baseURL, withCredentials: true });

  // Mirror the session-expiry interceptor from axiosInstance
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (
        error.response?.status === 403 &&
        error.response?.data?.Message ===
          'Session ended for the current user. Please login to continue.'
      ) {
        console.warn('[canguardNotificationsApi] Session expired. Prompting user to re-authenticate.');
        store.dispatch(showLoginModal());
        return Promise.reject(new Error('Session expired. Please log in again.'));
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

const canguardNotificationsApi = createCanguardNotificationsApiInstance();

export default canguardNotificationsApi;
